import script from "./DogListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DogListComponent.vue?vue&type=script&setup=true&lang=js"

import "./DogListComponent.vue?vue&type=style&index=0&id=308c6c9e&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-308c6c9e"]])

export default __exports__